import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "className", "children", "error", "label", "hint", "tooltip", "isInline", "isDisabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, cloneElement } from 'react';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import StyledFormField, { TooltipTrigger } from './FormField.styles';
import { cleanChildren } from '../../tools/functions';
import Tooltip from '../Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FormField = forwardRef(function (_ref, ref) {
  var _cx, _tooltip$icon;

  var id = _ref.id,
      customClassName = _ref.className,
      children = _ref.children,
      error = _ref.error,
      label = _ref.label,
      hint = _ref.hint,
      tooltip = _ref.tooltip,
      _ref$isInline = _ref.isInline,
      isInline = _ref$isInline === void 0 ? false : _ref$isInline,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-form-field"), true), _defineProperty(_cx, "".concat(prefix, "-form-field--inline"), isInline), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var validChildren = cleanChildren(children);
  var clones = validChildren.map(function (child, index) {
    return _jsx("div", {
      className: "".concat(prefix, "-form-field-control-item"),
      children: cloneElement(child, {
        isInvalid: Boolean(error),
        isDisabled: isDisabled
      })
    }, index);
  });
  return _jsxs(StyledFormField, _objectSpread(_objectSpread({
    ref: ref,
    className: className,
    id: id,
    label: label,
    labelInfo: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) && !(tooltip !== null && tooltip !== void 0 && tooltip.isDisabled) && _jsx(Tooltip, {
      content: tooltip.content,
      position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
      size: tooltip === null || tooltip === void 0 ? void 0 : tooltip.size,
      children: _jsx(TooltipTrigger, {
        icon: (_tooltip$icon = tooltip === null || tooltip === void 0 ? void 0 : tooltip.icon) !== null && _tooltip$icon !== void 0 ? _tooltip$icon : 'help',
        mode: 'light',
        size: 12
      })
    }),
    helperText: hint,
    isDisabled: isDisabled
  }, rest), {}, {
    children: [_jsx("div", {
      className: "".concat(prefix, "-form-field-control"),
      children: clones
    }), error && _jsx("div", {
      className: "".concat(prefix, "-form-field-error"),
      children: error
    })]
  }));
});
FormField.displayName = 'FormField';
export default FormField;